import React from 'react';
interface HighlightBoxProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  icon?: React.ReactNode;
}
export function HighlightBox({
  children,
  className = '',
  title,
  icon
}: HighlightBoxProps) {
  return <div className={`bg-white border border-[#e0ddd5] rounded-lg p-6 md:p-8 my-8 shadow-sm ${className}`} data-id="element-3">
      {(title || icon) && <div className="flex items-center gap-3 mb-4 border-b border-[#e0ddd5] pb-3" data-id="element-4">
          {icon && <span className="text-[#4a7c59]" data-id="element-5">{icon}</span>}
          {title && <h3 className="text-xl font-bold text-gray-900 font-sans" data-id="element-6">
              {title}
            </h3>}
        </div>}
      <div className="text-[#2c2c2c] font-serif leading-relaxed" data-id="element-7">
        {children}
      </div>
    </div>;
}